import diagramService, {DiagramService} from "../service/DiagramService";
import {PropertyApi} from "../../property/PropertiesPanel";
import {PropertyDefinitionDto, PropertyDto} from "../../../../../common/apis/property/PropertyApi";
import {DiagramPropertyDefinition} from "../../../../../common/DiagramPropertyDefinitionContext";
import {AttributeDefinitionDto} from "../../../../../common/apis/stereotype/AttributeDefinitionDto";


export class DiagramPropertyWrapperApi implements PropertyApi {

    private readonly apiClient: DiagramService;

    constructor(readonly diagramId: string,
                readonly propertyDefinitionContext: DiagramPropertyDefinition) {
        this.apiClient = diagramService;
    }

    getExistingPropertyDefinitions(): PropertyDefinitionDto[] {
        return this.propertyDefinitionContext.propertyDefinitions;
    }

    refreshExistingPropertyDefinitions(): void {
        this.propertyDefinitionContext.updatePropertyDefinitions();
    }

    findAllAttributeDefinitions(): Promise<AttributeDefinitionDto[]> {
        return Promise.resolve([]);
    }

    getProperties(): Promise<PropertyDto[]> {
        return this.apiClient.getAllDiagramProperties(this.diagramId);
    }

    createProperty(name: string, type: string, value: string, propertyDefinitionId: string | undefined): Promise<PropertyDto> {
        return this.apiClient.createDiagramProperty(this.diagramId, name, type, value, propertyDefinitionId)
            .then((propDefId) => {
                const property : PropertyDto = {
                    definition: {
                        identifier: propDefId,
                        name: name,
                        type: type
                    },
                    value: value
                };
                return property;
            });
    }

    updateProperty(propertyDefinitionId: string, value: string): Promise<void> {
        return this.apiClient.updateDiagramProperty(this.diagramId, propertyDefinitionId, value);
    }

    deleteProperty(propertyDefinitionId: string): Promise<void> {
        return this.apiClient.deleteDiagramProperty(this.diagramId, propertyDefinitionId);
    }

}